module.exports = __webpack_public_path__ + "media/images/sign-up-promo-932019e8a34e6fa3abfb7d9cf5b19a92.jpg";